export default {
    data() {
        return {};
    },
    methods: {
        sendSms(smsTemplateId, data, force = false) {
            this.isLoading = true;
            return new Promise((resolve) => {
                axios.post(`/sms/templates/${smsTemplateId}/send`, {data: data, sendForce: force})
                    .then((response) => {
                        console.log(response);
                        if (response.data.errors &&
                            !response.data.errors.length &&
                            Object.keys(response.data.errors).length === 1 &&
                            response.data.errors[data[0].bookingId] !== `Sms ${smsTemplateId} has already been sent for the booking ${data[0].bookingId}`
                        ) {
                            this.flashMessage.error({
                                title: '',
                                message: 'ERROR. ' + Object.values(response.data.errors)[0],
                                time: 2000,
                                blockClass: 'flash-message error'
                            });
                        } else if(response.data.sentSuccessfully &&
                            !response.data.sentSuccessfully.length &&
                            Object.keys(response.data.sentSuccessfully).length === 1
                        ) {
                            this.flashMessage.success({
                                title: '',
                                message: Object.values(response.data.sentSuccessfully)[0],
                                time: 2000,
                                blockClass: 'flash-message'
                            });
                        }

                        this.isLoading = false;
                        resolve(response.data);

                    }).catch((error) => {
                    console.error(error.response);
                    this.flashMessage.error({
                        title: '',
                        message: error.response.data.message || error.response.data || 'Error',
                        time: 4000,
                        blockClass: 'flash-message error'
                    });
                    this.isLoading = false;
                    resolve(false);
                });
            })
        },
    },
};
